import { Component, EventEmitter, Output } from '@angular/core';
import { CommonService } from '../../_services/app.common.service';

@Component({
    selector: 'app-header',
    templateUrl: './app-header.component.html',
    standalone: false
})
export class AppHeaderComponent {
  constructor() {

  }
  @Output() closeMenu = new EventEmitter();
  public openMoreMenu() {
    
    this.closeMenu.emit();
  }
  
//  <script>
//    export default {

//  name: 'more-menu',

//  props: [
//    'active',
//    'userName'
//  ],

//  data() {
//    return {
//      //
//    }
//  },

//  computed: {
//    user() {
//      return window.session.user
//    }
//  },

//  mounted() {
//    //
//  },

//  methods: {
//    closeMenu() {
//      $('.app_container').removeClass('freeze');
//      this.$parent.menuOpen = false
//    }
//  }
//}
//  < /script>

}



